import axios from "axios";
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBContainer,
  MDBRow,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink
} from 'mdb-react-ui-kit';

import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState , useContext} from 'react';
import { useParams } from 'react-router-dom';
import CategoryCard from './CategoryCard';
import CategoryFormModal from './CategoryFormModal';
import { CategoryContext } from "../context/CategoryContext";


function CategoryView({ firm, firmId , setIsCategoryFormSubmitted ,updateDomainCategories}) {
    const { domainId } = useParams();
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
   
    const [categoryToUpdate, setCategoryToUpdate] = useState(null);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const {setCategoryData,categoryData} = useContext(CategoryContext);
    const [activeTab, setActiveTab] = useState(categoryData && categoryData[0] && categoryData[0].name);
    const callModalToAdd = () => {
        setCategoryToUpdate(null);
        setShowCategoryModal(true);
    } 
    const fetchCategoriesByDomainId = useCallback(async (domainId) => {
        try {
            const response = await axios.get(`${baseUrl}/categories/domain/${domainId}`);
            return response.data;
        } catch (error) {
            console.error("An error occurred while fetching data: ", error);
        }
    }, [baseUrl]);
    
    useEffect(() => {
        const fetchData = async () => {
            const categories = await fetchCategoriesByDomainId(domainId);
            setCategoryData(categories);
            if (categories?.length > 0) {
                setActiveTab(categories[0].name);
            }
        };
    
        fetchData();
    }, [domainId, fetchCategoriesByDomainId]);
    
    
    const handleTabChange = (name) => {
        setActiveTab(name);
    }
    useEffect(() => {
       // setCategoryToUpdate(categoryToUpdate);
        setActiveTab(categoryData && categoryData[0] && categoryData[0].name);
      }, [categoryData]);

  
    
    return (
        <section className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center" >
        <MDBRow className='text-center rounded mt-3 gy-2 gx-3 align-items-center'>
  <MDBCol style={{ maxWidth: "400rem" ,borderRadius: "12px"}}>
        <MDBCard className='text-center rounded mt-3 gy-2 gx-3 align-items-center'> 
        {/* <MDBCardImage cascade style={{ height: '20rem' , borderRadius: "12px"}}   src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20%281%29.jpg" />
      <MDBCardOverlay tag="section" cascade className="text-center rounded" style={{ height: '20rem' , borderRadius: "12px" ,marginTop: "40px"}}>
  */}
      
            <MDBCardBody>
                {categoryData?.length>0  &&  <MDBCardHeader background="light" tag="section" className="text-center rounded">
                    
                <MDBTabs className='card-header-tabs'>
                {categoryData && categoryData.length > 0 && categoryData.map((category, index) => (
                        <MDBTabsItem key={index}>
                            <MDBTabsLink active={activeTab === category.name} onClick={() => handleTabChange(category.name)}>
                                {category.name}
                            </MDBTabsLink>
                        </MDBTabsItem>
                    ))}
                </MDBTabs>
            </MDBCardHeader>}
           
                <MDBRow className='text-center rounded mt-3 gy-2 gx-3 align-items-center'>
                {categoryData?.length>0  &&categoryData?.map((category, index) =>(
                        activeTab === category.name && (
                            <MDBCol  className='mb-4' key={index}>
                                <CategoryCard   key={category.id}
                                    category={category}                                
                                    setCategoryData={setCategoryData}
                                    setActiveTab={setActiveTab}
                                    activeTab={activeTab}     
                                    setIsCategoryFormSubmitted={setIsCategoryFormSubmitted}
                                    setShowCategoryModal={setShowCategoryModal}
                                    setCategoryToUpdate={setCategoryToUpdate}
                                    firm={firm}
                                   
                                    
                                />
                            </MDBCol>
                        )
                    ))}
                </MDBRow>
                {categoryData?.length ?? 0 ?  <MDBBtn className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2"  onClick={() => callModalToAdd()}>ADD</MDBBtn> :  <MDBBtn className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2" block onClick={() => callModalToAdd()}>ADD</MDBBtn>}
               
        

            </MDBCardBody>
            {/* </MDBCardOverlay> */}
        </MDBCard>
   <CategoryFormModal 
             firmId={firmId}
             setIsCategoryFormSubmitted={setIsCategoryFormSubmitted}
             setCategoryData={setCategoryData}
             setShowCategoryModal={setShowCategoryModal}
             showCategoryModal={showCategoryModal}
            categoryToUpdate={categoryToUpdate}
             setActiveTab={setActiveTab}
             prevCategories={categoryData}
             firm={firm}
             updateDomainCategories={updateDomainCategories}
          
        /> 
        
        </MDBCol>
               </MDBRow>
                    </section>
    );
}

CategoryView.propTypes = {
    setIsCategoryFormSubmitted: PropTypes.func,
    firm: PropTypes.string,
    firmId: PropTypes.string,
    updateDomainCategories: PropTypes.func,
  
    
}

export default CategoryView;
